const UTMIFY_UTMS_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'

/**
 * Loads the official UTMify UTM tracking script once.
 * Safe to call multiple times — subsequent calls are no-ops.
 */
export function loadUtmify(): void {
  if (typeof document === 'undefined') return
  if (document.querySelector(`script[src="${UTMIFY_UTMS_SRC}"]`)) return

  const script = document.createElement('script')
  script.src = UTMIFY_UTMS_SRC
  script.async = true
  script.defer = true
  script.setAttribute('data-utmify-prevent-xcod-sck', '')
  script.setAttribute('data-utmify-prevent-subids', '')
  document.head.appendChild(script)
}
